import axiosInstance from "./axiosInstance";

const analyzerService = {
  getConfig: async () => {
    const response = await axiosInstance.get("/analyzer/config");
    return response.data;
  },

  saveConfig: async (keitaroApiKey) => {
    const response = await axiosInstance.post("/analyzer/config", {
      keitaroApiKey,
    });
    return response.data;
  },

  getGroups: async () => {
    try {
      const response = await axiosInstance.get("/analyzer/groups");
      return response.data.groups;
    } catch (error) {
      console.error("Помилка отримання груп:", error);
      throw error;
    }
  },

  runAnalysis: async (from, to, groupId) => {
    try {
      const params = {};
      if (from) params.from = from;
      if (to) params.to = to;
      if (groupId && groupId !== "all") params.group_id = groupId;

      const response = await axiosInstance.get("/analyzer/analyze", {
        params: params,
      });
      return response.data;
    } catch (error) {
      console.error("Помилка аналізу:", error);
      throw error;
    }
  },

  getCampaignBreakdown: async (id, from, to, dimension) => {
    try {
      const params = { from, to, dimension };
      const response = await axiosInstance.get(
        `/analyzer/campaign/${id}/breakdown`,
        {
          params,
        },
      );
      return response.data.breakdown;
    } catch (error) {
      console.error("Помилка отримання розбивки:", error);
      throw error;
    }
  },
};

export default analyzerService;
